import { render, staticRenderFns } from "./MChartBar.vue?vue&type=template&id=581cebf2&"
import script from "./MChartBar.vue?vue&type=script&lang=js&"
export * from "./MChartBar.vue?vue&type=script&lang=js&"
import style0 from "./MChartBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
